import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  fixtureMatchSchema,
  fixtureMatchListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/paymentEvents/actions';
import { PaymentEventsActionTypes as types } from 'app/ducks/paymentEvents/types';

function* createPaymentEventSaga(action): any {
  yield put(sagaActions.createPaymentEventPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).fixtureMatches.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchSchema);

    yield put(sagaActions.createPaymentEventSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createPaymentEventFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updatePaymentEventSaga(action): any {
  yield put(sagaActions.updatePaymentEventPending(action.payload.data));
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).fixtureMatches.update(
    action.payload.data,
    action.payload.fixtureMatchDashboardId,
  );

  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchSchema);

    yield put(sagaActions.updatePaymentEventSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updatePaymentEventFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getPaymentEventSaga(action): any {
  yield put(sagaActions.getPaymentEventPending());
  const [error, response] = yield (yield TeammoApi(yield select())).fixtureMatches.show(
    action.payload.id,
    null,
    action.payload.eventDashboardId,
  );
  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchSchema);
    yield put(sagaActions.getPaymentEventSuccess(normalizedResponse));
    return normalizedResponse.entities.fixtureMatches[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getPaymentEventFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    ),
  );
  return null;
}

function* getAllPaymentEventsSaga(action): any {
  yield put(
    sagaActions.getAllPaymentEventsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  let paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.paymentEvents.pagination),
    )
    : action.payload.pagination;

  paginationObject = { ...paginationObject };

  const [error, response] = yield (yield TeammoApi(yield select())).fixtureMatches.list(
    paginationObject,
    action.payload.eventDashboardId,
  );

  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchListSchema);
    yield put(
      sagaActions.getAllPaymentEventsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllPaymentEventsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createPaymentEventSagaWatcher(): any {
  yield takeEvery(
    types.CREATE_PAYMENT_EVENT_REQUESTED,
    createPaymentEventSaga,
  );
}

function* updatePaymentEventSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_PAYMENT_EVENT_REQUESTED,
    updatePaymentEventSaga,
  );
}

function* getPaymentEventSagaWatcher(): any {
  yield takeLatest(
    types.GET_PAYMENT_EVENT_REQUESTED,
    getPaymentEventSaga,
  );
}

function* getAllPaymentEventsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_PAYMENT_EVENTS_REQUESTED,
    getAllPaymentEventsSaga,
  );
}

export default function* root(): any {
  yield all([
    createPaymentEventSagaWatcher(),
    updatePaymentEventSagaWatcher(),
    getPaymentEventSagaWatcher(),
    getAllPaymentEventsSagaWatcher(),
  ]);
}
